import React from "react";
import { Flex, Text } from "@radix-ui/themes";

export function EatAppMark() {
  return (
    <Flex
      width="40px"
      height="40px"
      align="center"
      justify="center"
      style={{
        flexShrink: 0,
        borderRadius: "var(--space-1)",
        background: "#FFFFFF",
        border: "1px solid var(--gray-a6)",
      }}
    >
      <Text size="3" weight="bold" style={{ color: "#00a86b", letterSpacing: "-0.04em" }}>
        eat
      </Text>
    </Flex>
  );
}
